import { memo } from 'react';
const SvgRotateCw = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="rotate-cw_svg__feather rotate-cw_svg__feather-rotate-cw"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M23 4v6h-6" />
    <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
  </svg>
);
const Memo = memo(SvgRotateCw);
export default Memo;
